import Vue from 'vue';
import businessHourTransformer from './../../transformers/businessHour';
import all from './all';
import store from './../../store';

const success = (resolve, b) => {
  store.dispatch('storeBusinessHour', b);
  all();
  resolve();
};

const failed = (errors, reject) => {
  reject(businessHourTransformer.fetch(errors));
};

export default businessHour => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post('business_hours', businessHourTransformer.send(businessHour))
    .then(() => {
      success(resolve, businessHour);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/businessHour/store.js